import { render, staticRenderFns } from "./TableForm15.vue?vue&type=template&id=76ca23a9&scoped=true"
import script from "./TableForm15.vue?vue&type=script&lang=ts"
export * from "./TableForm15.vue?vue&type=script&lang=ts"
import style0 from "./TableForm15.vue?vue&type=style&index=0&id=76ca23a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca23a9",
  null
  
)

export default component.exports